export default "https://cdn-static.gokick.com/assets/75ac565edfb9d82dbbe43c50f72b37b3535e18ca/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";